var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"row"},[_c('dt',{staticClass:"col-5"},[_vm._v(_vm._s(_vm.field))]),_vm._v(" "),(!_vm.clickable)?_c('dd',{staticClass:"col-7"},[_vm._v(_vm._s(_vm._f("isEmpty")(_vm.value)))]):_c('dd',{staticClass:"col-7",on:{"click":_vm.onClick}},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm._f("isEmpty")(_vm.value)))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70a13d68","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Osm/ServiceRequest/components/ServiceRequestDetailRow.vue
// module id = null
// module chunks = 